module.exports = __webpack_public_path__ + "static/media/one-bed-spacious-bg-1.e9b0c5bc.jpg";